import React from 'react'
import ReactDOM from 'react-dom/client'
import Standalone from './Standalone'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
 <React.StrictMode>
  <Standalone />
 </React.StrictMode>,
)
